var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6163",
    stroke: "#FF6163",
    strokeWidth: 1.5,
    d: "M8.835 2.683a.747.747 0 00-1.006.336L1.677 15.5c0 .207.084.395.22.53.135.136.323.22.53.22l12.481-.08a.747.747 0 00.336-1.005L8.835 2.683z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.791 7.791v3.542a.709.709 0 001.417 0V7.791a.708.708 0 00-1.417 0zm1.417 5.667a.708.708 0 10-1.416-.002.708.708 0 001.416.002z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.62622ae7.svg";
export { ForwardRef as ReactComponent };